export default {
  GeneralError: {
    Title:
      'Wygląda na to, że coś poszło nie tak - może spróbujemy jeszcze raz?',
    Button: {
      Return: 'Wróć do poprzedniej strony',
      Contact: 'Skontaktuj się z nami',
    },
    Or: 'lub',
  },
  CantInsure: {
    Title:
      'Nie możemy zaproponować Ci oferty online',
    HelpText:
      'Skontaktuj się z naszym konsultantem by dowiedzieć się jak możemy Ci pomóc. Zadzwoń pod number 22 501 35 01.',
  },
  NotFoundError: {
    Title: 'Ubzzzzz, strony nie znaleziono',
    Text: 'Za chwilkę przekieruje Cię na działającą stronę:',
  },
};
